import { useEffect } from 'react';
import { useAuthStore, useLibraryStore } from '../../../../../store/hooks';
import { useLibraryApi } from '../../../../../apiHooks';
import { useSwitchActive } from '../../useSwitchActive.vm';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { GeneralLink, generateLink } from '../../../../../utils';
import { useCookies } from 'react-cookie';

export const useLinks = (handleOpen: (type: string, id?: number) => void) => {
  const libraryStore = useLibraryStore();
  const { categories, linkArticles } = libraryStore;
  const { getArticles } = useLibraryApi();
  const { roleFunction } = useAuthStore();
  const params = useParams();
  const { libType } = params;
  const { checked, handleChange } = useSwitchActive();
  const navigate = useNavigate();
  const location = useLocation();
  const id = categories && categories.find(el => el.label === libType)?.id;
  const [, setCookie] = useCookies(['redirectLink']);

  useEffect(() => {
    if (libType && id) {
      void getArticles(id);
    }
    return () => libraryStore.clearArticles();
  }, [getArticles, libType, libraryStore, id]);

  const handleDelete = (id: number) => {
    handleOpen('delete', id);
  };

  const handleClickByGuest = () => {
    const link = generateLink(roleFunction, GeneralLink.LOGIN_USER);
    setCookie('redirectLink', location.pathname);
    navigate(link);
  };

  return {
    linkArticles,
    roleFunction,
    handleDelete,
    handleChange,
    checked,
    handleClickByGuest
  };
};